export default "__VITE_ASSET__Bjp5Qh$7__"